import { ca } from '@cian/analytics';

export function trackOfferTeaserShow(offerId: number, position: number) {
  ca('teaser', {
    product: {
      id: offerId,
      name: 'show_card',
      extra: {
        offerType: 'offer',
      },
      position: position + 1,
      screen: 'CompareScreen',
      block: 'Compare',
    },
  });
}
